export default __webpack_public_path__ + "static/media/IPHome_Black.b62a59d4.svg";